import {Button, Input, Tag, Typography} from 'antd';
import CardItem from './CardItem';
import {useState} from 'react';
const {Text} = Typography;

const ShippingTags = ({ tags, updateTags }) => {
  const [tag, setTag] = useState('');

  const addTag = () => {
    updateTags(tag);
    setTag('');
  }
  return (
    <CardItem>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          gap: '10px',
        }}
      >
        <Text
          style={{
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '16px',
            color: '#1F2D3D',
          }}
        >
          Shipping Tags
        </Text>
        <Input onPressEnter={addTag} value={tag} onChange={e => setTag(e.target.value)} placeholder="Add Shipping Tags" />
        <Button
          onClick={() => {
            updateTags(tag);
            setTag('');
          }}
          className="secondary_button"
        >
          + Add Tag
        </Button>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {tags.map((tag, idx) => (
          <Tag style={{display: 'flex', alignItems: 'center', gap: '10px'}} key={tag}>
            <Text style={{fontSize: '15px', fontWeight: 500, lineHeight: '14px', color: '#1F2D3D'}}>{tag}</Text>
            <Button onClick={() => updateTags(tag, idx, true)} style={{padding: 0}} width={10} height={10} type="ghost">
              <img alt="closeIcon" src="/closeIcon.svg" width={15} height={15} />
            </Button>
          </Tag>
        ))}
      </div>
    </CardItem>
  );
};

export default ShippingTags;
